export default {
  id: "saleTypetimeSeriesSales",
  name: "",
  description: "",
  report: {
    name: "Daily Units Sold By Sale Type",
    chartType: "COLUMN",
    template: "custom",
    config: {
      dataType: "time_series",
      dataSet: "Sale",
      dimensions: ["Sale.sale_type"],
      measures: ["Sale.count"],
      sort: {
        direction: "desc",
        by: "Sale.count",
      },
      filters: [],
      compare: false,
      limit: "5",
      rowTotals: false,
      stacked: true,
      points: false,
      colorTheme: "default",
    },
  },
};
